module.exports = __webpack_public_path__ + "img/danci.236cb837.png";